export interface OrderStatus {
  orderId: string;
  status: string;
}
